// ABOUTME: Synchronizes product discount badges with completed variant selections.
// ABOUTME: Uses Shopify's contextual discount, including no-discount states.
// DATA FLOW: variant:update section HTML -> matching gallery/sticky badge.
// DEPENDENCIES: Theme variant:update event and peptik-pdp-discount-badge.liquid.
class PeptikDiscountBadge extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener('variant:update', this.update, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  update = (event) => {
    const placement = this.dataset.peptikDiscountPlacement;
    const incoming = event.detail.data.html.querySelector(`peptik-discount-badge[data-peptik-discount-placement="${placement}"] [data-peptik-pdp-disc]`);
    const badge = this.querySelector('[data-peptik-pdp-disc]');
    badge.hidden = !incoming || incoming.hidden;
    if (incoming) badge.textContent = incoming.textContent;
  };
}

if (!customElements.get('peptik-discount-badge')) {
  customElements.define('peptik-discount-badge', PeptikDiscountBadge);
}
